var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import Alert from 'components/ui/Alert';
import { Translation, withTranslation } from 'react-i18next';
import PhoneField from 'components/v2/forms/PhoneField';
import CustomerSearch from '../../site/customer-search';
import UserActionCreators from '../../../actions/UserActionCreators';
import FormCard from '../../v2/FormCard';
import SessionStore from '../../../stores/SessionStore';
function getInitialState() {
    return {
        carrier_name: '',
        carrier: '',
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        password: '',
        username: '',
        isCustomerManager: SessionStore.isCustomerManagerAdmin(),
    };
}
class RegisterDriver extends Component {
    constructor(props) {
        super(props);
        this.handlePhoneChange = (phone) => {
            this.setState({ phone });
        };
        this.handleCustomerSelect = (carrier_name, details) => {
            this.setState((prevState) => {
                return Object.assign(Object.assign({}, prevState), { carrier_name, carrier: details.value });
            });
        };
        this.handleRegister = (e) => {
            e.preventDefault();
            const _a = this.state, { carrier_name, isCustomerManager } = _a, driver = __rest(_a, ["carrier_name", "isCustomerManager"]);
            UserActionCreators.addDriver(driver);
            this.setState(getInitialState());
        };
        this.state = getInitialState();
    }
    handleChange(field) {
        return (e) => this.setState({ [field]: e.target.value });
    }
    valid() {
        const { email, first_name, last_name, phone, password, username } = this.state;
        return !(email && first_name && last_name && phone && password && username);
    }
    renderForm() {
        const { t } = this.props;
        const isCustomerManager = this.state.isCustomerManager;
        const disabled = !this.state.carrier || !isCustomerManager;
        return (React.createElement(FormCard, { actions: () => (React.createElement("button", { disabled: disabled || this.valid(), className: "button button-green", type: "submit", onClick: this.handleRegister }, t('REGISTER'))) },
            !isCustomerManager && (React.createElement(Alert, { type: "warning" },
                React.createElement(Translation, null, (t) => React.createElement("p", null, t('REQUIRED_CUSTOMER_MANAGER_PRIVILEGES'))))),
            React.createElement("div", null,
                React.createElement("h3", { className: "mb-4 text-lg font-medium text-gray-900 leading-6" }, t('DRIVER_PROFILE'))),
            React.createElement("div", { className: "grid grid-cols-4 gap-6" },
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('FIRST_NAME')),
                    React.createElement("input", { type: "text", placeholder: "John", className: "w-full mb-4 form-field", disabled: disabled, onChange: this.handleChange('first_name'), value: this.state.first_name })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('LAST_NAME')),
                    React.createElement("input", { type: "text", placeholder: "Smith", className: "w-full mb-4 form-field", disabled: disabled, onChange: this.handleChange('last_name'), value: this.state.last_name })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PHONE')),
                    React.createElement(PhoneField, { value: this.state.phone, onChange: this.handlePhoneChange })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('USERNAME')),
                    React.createElement("input", { type: "text", placeholder: "JohnSmith", className: "w-full mb-4 form-field", disabled: disabled, onChange: this.handleChange('username'), value: this.state.username })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('EMAIL')),
                    React.createElement("input", { type: "email", placeholder: "jsmith@cargomatic.com", className: "w-full mb-4 form-field", disabled: disabled, onChange: this.handleChange('email'), value: this.state.email })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "mb-2 form-label" }, t('PASSWORD')),
                    React.createElement("input", { type: "password", className: "block w-full mb-4 form-field", disabled: disabled, onChange: this.handleChange('password'), value: this.state.password })))));
    }
    render() {
        const { t } = this.props;
        const isCustomerManager = this.state.isCustomerManager;
        return (React.createElement("section", null,
            React.createElement("div", { className: "mb-6" },
                React.createElement(FormCard, null,
                    React.createElement("h3", { className: "block mb-2 text-lg font-medium leading-6" }, t('SELECT_A_CARRIER')),
                    React.createElement(CustomerSearch, { clearOnSelect: true, onSelect: this.handleCustomerSelect, type: "carriers", disabled: !isCustomerManager }))),
            this.renderForm()));
    }
}
export default withTranslation()(RegisterDriver);
